<template>
  <div id="bidDetail">
    <!--双向逆变器： 设备基本信息 -->
    <el-row>
      <div class="paneDivWarp" style="padding-bottom: 45px;">
        <p class="flowP">
          {{ bidSn }}
          <span>{{ bidInfoTem.timeAgo }}</span>
        </p>
        <div class="flowDivWarp">
          <img v-if="!bidInfoTem.online" src="@/assets/images/kisae/flowChart/bidOfflineFlow.jpg" alt="" style="width: 100%;">
          <img v-else :src="bidFlowUrl" alt="" style="width: 100%;">
          <div class="altData flowDataDiv">
            <p>{{ bidInfoTem.altV }} V</p>
            <!-- <p>{{ bidInfoTem.altA }} A</p> -->
          </div>

          <div class="centInfo">
            <p>{{ bidInfoTem.inverterTemperature}} ℃</p>
          </div>

          <div class="machineData flowDataDiv">
            <p style="width: 300px; text-align: left; margin-left: 15px;">{{ bidInfoTem.inverterOutVol }} V  /  {{ bidInfoTem.inverterOutCur }} A</p>
            <p>{{ bidInfoTem.bidOutputPower }} W</p>
          </div>
          <div class="batteryData flowDataDiv">
            <p>{{ bidInfoTem.batteryV }} V</p>
            <p>{{ bidInfoTem.batteryA }} A</p>
          </div>
        </div>
      </div>
      <!-- 状态 -->
      <div class="paneDivWarp paneDivStatusWarp">
        <div v-if="bidInfoTem.isShowStatus" class="divWarp25">
          <div class="paneDivStatusImg">
            <img v-if="!bidInfoTem.online" src="@/assets/images/kisae/chargeStage_offline.png" alt="">
            <img v-else-if="bidInfoTem.online&&bidInfoTem.status===0" src="@/assets/images/kisae/3-1.png" alt="">
            <img v-else-if="bidInfoTem.online&&bidInfoTem.status==1" src="@/assets/images/kisae/3-2.png" alt="">
            <img v-else-if="bidInfoTem.online&&bidInfoTem.status==2" src="@/assets/images/kisae/3-3.png" alt="">
            <img v-else src="@/assets/images/kisae/chargeStage_online.png" alt="">
          </div>
          <div class="paneDivStatusP">
            <p>STATUS</p>
            <p v-if="bidInfoTem.online&&bidInfoTem.status===1" class="statusP">Bulk</p>
            <p v-else-if="bidInfoTem.online&&bidInfoTem.status==2" class="statusP">ABS</p>
            <p v-else-if="bidInfoTem.online&&bidInfoTem.status==3" class="statusP">Float</p>
            <p v-else class="statusP">--</p>
          </div>
        </div>
        <div v-else class="divWarp25">
          <div class="paneDivStatusImg">
            <!-- <img src="@/assets/images/kisae/current_online.png" alt="" style="width: 23%;"> -->
            <!-- <img v-if="!bidInfoTem.online||!bidInfoTem.sense||bidInfoTem.sense=='--'" src="@/assets/images/kisae/sense_offline.png" alt="" style="width: 23%;"> -->
            <img v-if="bidInfoTem.online" src="@/assets/images/kisae/sense_online.png" alt="">
            <img v-else src="@/assets/images/kisae/sense_offline.png" alt="">
          </div>
          <div class="paneDivStatusP">
            <p>LOAD SENSE</p>
            <p v-if="bidInfoTem.sense=='1'||bidInfoTem.sense=='2'||bidInfoTem.sense=='3'||bidInfoTem.sense=='4'" class="statusP">ON</p>
            <p v-else-if="bidInfoTem.sense=='5'" class="statusP">OFF</p>
            <p v-else class="statusP">--</p>
          </div>
        </div>
      </div>
      <!-- 警告 -->
      <div class="paneDivWarp warningWarp">
        <el-table :data="warningList" style="width: 100%" :show-header="false" empty-text="The device has no warning for the time being.">
          <el-table-column width="100">
            <template slot-scope="scope">
              <img :src="scope.row.imgUrl" alt="" style="width: 80px;">
              <!-- <img src="@/assets/images/warningSimpleImg/E02.png" alt=""> -->
            </template>
          </el-table-column>
          <el-table-column prop="question">
            <template slot-scope="scope">
              <span>{{ scope.row.question }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="answer" />
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { updateTimeOnlyEn } from '@/utils/updateTime.js'

export default {
  name: '',
  props: {
    bidTabPaneInfo: {
      type: Object,
      default: () => { }
    },
    bidSn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bidInfoTem: {
        altV: '--',
        altA: '--',
        bidOutputPower: '--',
        batteryA: '--',
        batteryV: '--',
        sense: '--',
        isCharged: 'charged',
        isShowStatus: true,
        timeAgoRes: null,
        timeAgo: null,
        inverterTemperature: '--',
        inverterOutVol: '--',
        inverterOutCur: '--',
      },
      bidFlow: '',
      bidFlowUrl: '',
      warningList: [],
      warningBidInfo: [// 双项逆变器 警告文字
        { key: 'E01', question: 'When unit is in Battery/inverter mode, Input battery voltage is too low and AC Output is shutdown.', answer: 'Recharge the battery immediately and restart unit.' },
        { key: 'E02', question: 'When unit is in Battery/inverter mode, battery voltage is too high and unit has shutdown', answer: 'Check battery voltage or determine if any external charger is connected to the battery bank' },
        { key: 'E03', question: 'When unit is in Battery/inverter mode, AC output is overloaded or short circuited and unit has shutdown', answer: 'Check load connected to the output. Reduce load and restart the unit' },
        { key: 'E04', question: 'When unit is in Battery/inverter mode Internal temperature is too high and unit has shutdown', answer: 'Turn unit off and wait for 15 minutes before restarting. Check if any object has blocked the air flow of the unit' },
        { key: 'E05', question: 'When unit is in Battery/inverter mode Input battery voltage is low and warning occurs', answer: 'Recharge battery as unit will shutdown shortly' },
        { key: 'E06', question: 'When unit is in Battery/inverter mode AC output load connected has been sensed high and is close to shutdown limit', answer: 'Reduce load' },
        { key: 'E07', question: 'When unit is in Batter/inverter mode Internal temperature is high and is close to over temperature shutdown limit', answer: 'Reduce load and check if any ventilation of the unit is blocked' },
        { key: 'E10', question: 'When unit is in By-pass mode, Battery Charging voltage too high', answer: 'Check battery setting' },
        { key: 'E11', question: 'When unit is in By-pass mode, Battery fault, battery does not accept charge.', answer: 'Check battery' },
        { key: 'E12', question: 'When unit is in By-pass mode, Internal transfer switch temperature is high and shutdown occurs', answer: 'Reduce load and check if any ventilation of the unit is blocked' },
        { key: 'E13', question: 'AC Output GFCI Tripped', answer: 'Check the GFCI installed in the unit. Reset the GFCI.' },
        { key: 'E14', question: 'Display panel has communication error', answer: 'Check RJ12 cable connected between the main and Display panel' },
        { key: 'E15', question: 'AC Back Feed to Unit AC Output', answer: 'Check AC Output wiring' }
      ],
      timer: null
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    bidTabPaneInfo: {
      handler(newValue, oldValue) {
        this.MQTT()
      },
      deep: true,
      immediate: true
    },
    language(newValue, oldValue) {
      if (this.bidInfoTem.timeAgoRes) this.bidInfoTem.timeAgo = updateTimeOnlyEn(this.bidInfoTem.timeAgoRes)
    }
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  mounted() {

  },
  methods: {
    MQTT() {
      console.log('mqtt**bidTem********', this.bidTabPaneInfo)
      if (this.bidTabPaneInfo.dataFrom == 'api') {
        this.bidInfoTem.timeAgoRes = this.bidTabPaneInfo.timeAgoRes
        this.bidInfoTem.timeAgo = updateTimeOnlyEn(this.bidInfoTem.timeAgoRes)
        this.bidInfoTem.online = false
      } else if (this.bidTabPaneInfo.dataFrom == 'mqtt') {
        if (!this.bidTabPaneInfo) return
        this.bidInfoTem.timeAgo = 'A Moment Ago'
        this.bidInfoTem.timeAgoRes = new Date().getTime()
        this.bidInfoTem.altV = this.bidInfoTem.altA = this.bidInfoTem.batteryV = this.bidInfoTem.batteryA = this.bidInfoTem.bidOutputPower = '--'
        if (this.bidTabPaneInfo.connection === 1) { // 设备状态 1：连接 2：断开
          this.bidInfoTem.online = true
        } else {
          this.bidInfoTem.online = false
        }
        if ((this.bidTabPaneInfo.inverterOutCur > 0 && this.bidTabPaneInfo.invOutputPower > 0) || this.bidTabPaneInfo.inverterStatus == 1) { // 放电
          this.bidInfoTem.isCharged = 'disCharged'
          this.isShowStatus = false
          this.bidFlow = 'bidDischargeFlow.gif'
          this.bidFlowUrl = require('@/assets/images/kisae/flowChart/' + this.bidFlow)
          this.bidInfoTem.batteryA = (this.bidTabPaneInfo.batCurrent / 100).toFixed(2)
          this.bidInfoTem.batteryV = (this.bidTabPaneInfo.batVoltage / 100).toFixed(2)
          this.bidInfoTem.bidOutputPower = this.bidTabPaneInfo.invOutputPower
          this.bidInfoTem.inverterTemperature = (this.bidTabPaneInfo.inverterTemperature).toFixed(2)
        } else {
           // 逆变
          if (this.bidTabPaneInfo.acVol < 9000 && this.bidTabPaneInfo.batVoltage > 100 && this.bidTabPaneInfo.inverterOutVol > 9000) {
            this.isShowStatus = true
            this.bidFlow = 'bidDischargeFlow.gif'
            this.bidFlowUrl = require('@/assets/images/kisae/flowChart/' + this.bidFlow)
            //this.bidInfoTem.altV = Math.round(this.bidTabPaneInfo.acVol / 100)
            this.bidInfoTem.inverterOutVol = (this.bidTabPaneInfo.inverterOutVol / 100).toFixed(2)
            this.bidInfoTem.inverterOutCur = ((this.bidTabPaneInfo.inverterOutCur ? this.bidTabPaneInfo.inverterOutCur : 0) / 100).toFixed(2)
            this.bidInfoTem.bidOutputPower = (this.bidTabPaneInfo.inverterOutVol * (this.bidTabPaneInfo.inverterOutCur ? this.bidTabPaneInfo.inverterOutCur : 0) / 10000).toFixed(2)
            this.bidInfoTem.batteryA = (this.bidTabPaneInfo.batCurrent / 100).toFixed(2)
            this.bidInfoTem.batteryV = (this.bidTabPaneInfo.batVoltage / 100).toFixed(2)
            this.bidInfoTem.inverterTemperature = (this.bidTabPaneInfo.inverterTemperature).toFixed(2)
          }  // 充电
          else if (this.bidTabPaneInfo.acVol > 0 && this.bidTabPaneInfo.inverterStatus != 1 && this.bidTabPaneInfo.chargeSwitch == 1 && (this.bidTabPaneInfo.totalPowerAC - this.bidTabPaneInfo.chargePower) <= 1) {
            this.isShowStatus = true
            this.bidFlow = 'bidToBatteryFlow.gif'
            this.bidFlowUrl = require('@/assets/images/kisae/flowChart/' + this.bidFlow)
            this.bidInfoTem.altV = Math.round(this.bidTabPaneInfo.acVol / 100)
            this.bidInfoTem.batteryA = (this.bidTabPaneInfo.chargeCur / 100).toFixed(2)
            this.bidInfoTem.batteryV = (this.bidTabPaneInfo.chargeVol / 100).toFixed(2)

            this.bidInfoTem.inverterOutVol = (this.bidTabPaneInfo.inverterOutVol / 100).toFixed(2)
            this.bidInfoTem.inverterOutCur = ((this.bidTabPaneInfo.inverterOutCur ? this.bidTabPaneInfo.inverterOutCur : 0) / 100).toFixed(2)
            this.bidInfoTem.bidOutputPower = (this.bidTabPaneInfo.inverterOutVol * (this.bidTabPaneInfo.inverterOutCur ? this.bidTabPaneInfo.inverterOutCur : 0) / 10000).toFixed(2)
            this.bidInfoTem.inverterTemperature = (this.bidTabPaneInfo.inverterTemperature).toFixed(2)

          } else if (this.bidTabPaneInfo.acVol > 0 && this.bidTabPaneInfo.inverterStatus != 1 && this.bidTabPaneInfo.chargeSwitch == 2) {
            this.isShowStatus = false
            this.bidFlow = 'bidToMachineFlow.gif'
            this.bidFlowUrl = require('@/assets/images/kisae/flowChart/' + this.bidFlow)
            this.bidInfoTem.altV = Math.round(this.bidTabPaneInfo.acVol / 100)
            this.bidInfoTem.bidOutputPower = this.bidTabPaneInfo.totalPowerAC - this.bidTabPaneInfo.chargePower
            this.bidInfoTem.inverterTemperature = (this.bidTabPaneInfo.inverterTemperature).toFixed(2)
          } else if (this.bidTabPaneInfo.acVol > 0 && this.bidTabPaneInfo.inverterStatus != 1 && this.bidTabPaneInfo.chargeSwitch == 1 && (this.bidTabPaneInfo.totalPowerAC - this.bidTabPaneInfo.chargePower) > 1) {
            this.isShowStatus = true
            this.bidFlow = 'bidToBatAndMacFlow.gif'
            this.bidFlowUrl = require('@/assets/images/kisae/flowChart/' + this.bidFlow)
            this.bidInfoTem.altV = Math.round(this.bidTabPaneInfo.acVol / 100)
            this.bidInfoTem.batteryA = (this.bidTabPaneInfo.chargeCur / 100).toFixed(2)
            this.bidInfoTem.batteryV = (this.bidTabPaneInfo.chargeVol / 100).toFixed(2)
            this.bidInfoTem.bidOutputPower = this.bidTabPaneInfo.totalPowerAC - this.bidTabPaneInfo.chargePower
            this.bidInfoTem.inverterTemperature = (this.bidTabPaneInfo.inverterTemperature).toFixed(2)
          }
        }
        this.bidInfoTem.status = this.bidTabPaneInfo.chargeStage
        this.bidInfoTem.sense = this.bidTabPaneInfo.lowPowerMode
        this.warningList = []
        // this.bidTabPaneInfo.errorCode = 5 // 假数据
        if (this.bidTabPaneInfo.errorCode) { // 警告
          var errors = this.bidTabPaneInfo.errorCode
          // console.log('errors----------', errors)
          this.warningBidInfo.forEach(v => {
            if (errors <= 7 && (v.key == ('E0' + errors))) {
              this.warningList.push({
                imgUrl: require('@/assets/images/warningSimpleImg/E0' + errors + '.png'),
                question: v.question,
                answer: v.answer
              })
            } else if (errors <= 15 && errors >= 10 && (v.key == ('E' + errors))) {
              this.warningList.push({
                imgUrl: require('@/assets/images/warningSimpleImg/E' + errors + '.png'),
                question: v.question,
                answer: v.answer
              })
            }
          })
        }
        if (!this.bidInfoTem.online) {
          for (var k in this.bidInfoTem) {
            if (k != 'online') {
              this.bidInfoTem[k] = '--'
              this.warningList = []
            }
          }
        }
        // console.log('mqtt**bidInfoTem********', this.bidInfoTem)
      }
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.bidInfoTem.timeAgoRes) this.bidInfoTem.timeAgo = updateTimeOnlyEn(this.bidInfoTem.timeAgoRes)
        }, 60000)
      }
    }
  }
}
</script>

<style lang="scss">
#bidDetail{
  .altData{
    left: calc(8.4% - 40px);
    top: 30%;
    text-align: center;
  }
  .machineData{
    left: calc(49% - 40px);
    top: 99.4%;
  }
  .batteryData{
    left: calc(93.4% - 40px);
    top: 33%;
  }
  .centInfo {
    width: 200px;
    left: calc(50% + 20px);
    top: 33%;
    position: absolute;
  }
}
</style>
